import { Box, Divider, Typography } from '@mui/material'
import React from 'react'

const Capsule = ({children, sx, title, contentSX}) => {
  return (
    <Box sx={{
        border:1, 
        borderRadius:1, 
        borderColor: '#ccc', 
        backgroundColor:'#fff',
        width: '100%',
        ...sx
    }}>
        {title?<><Typography 
          variant="h4"
          p={1}
          sx={{ ml:1, color: "primary.main", fontWeight: "regular" }}
        >{title}</Typography><Divider sx={{ borderColor: 'rgba(0, 0, 0, 0.1)' }}/></>:null}
        <Box sx={{ p: 2, ...contentSX }}>
          {children}
        </Box>
    </Box>
  )
}

export default Capsule